<template>
    <div class="page">
        <!-- <modalLoading ref="modalLoading" /> -->
        <product_add_cart_success_modal ref="product_add_cart_success_modal" :curr="curr" />
        <!-- 邀请好友 -->
        <!-- <modalYaoqing ref="modalYaoqing" /> -->
        <!-- 添加成功提示 -->
        <!-- 右侧优惠券列表 -->
        <!-- <goodsCouponList ref="goodsCouponList" :list="info.yhq_list" /> -->
        <!-- <pageProductTop /> -->
        <div class="fill60"></div>
        <pageBreadcrumb :option="nav_option" />
        <div class="fill60"></div>

        <div class="page-box">
            <div class="page-inner">
                <div class="main-content">
                    <div class="ctx-top">
                        <div class="ctx-left">
                            <goods_image_mask class="elImg" :src="swiperImgs[swiperIndex]" :bigSrc="swiperImgs[swiperIndex]" />

                            <div class="swiperBigBox swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="(item, index) in swiperImgs" :key="index">
                                        <el-image
                                            @click="switchImg(index)"
                                            class="swiperImg"
                                            :class="{ active: !!(index == swiperIndex) }"
                                            :src="item"
                                            fit="cover"
                                        ></el-image>
                                    </div>
                                </div>
                            </div>

                            <div class="swiperLastBtn"></div>
                            <div class="swiperNextBtn"></div>
                        </div>

                        <div class="ctx-right">
                            <div class="otherBox">
                                <div class="detail-title">
                                    <div class="title-text">
                                        {{ lang == 'en' ? info.enTitle : info.title }}
                                    </div>
                                    <div class="price-box">{{ vuex_huobi }} {{ select_inventoryId.priceSale }}</div>
                                </div>
                                <!-- <div class="detail-desc" v-if="info.subtitle">
                                {{ info.subtitle }}
                            </div> -->
                                <!-- <div class="detail-desc" v-if="info.jianjie">
                                {{ info.jianjie }}
                            </div> -->

                                <!-- <div class="info-box">
                                <div class="list">
                                    <div class="item" style="margin-bottom: 10px">
                                        <div class="label">销售价</div>
                                        <div class="vals vals-price">
                                            <div class="val">{{ vuex_huobi }} {{ view_info.priceSale }}</div>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="label">市场价</div>
                                        <div class="vals">
                                            <div class="val" style="text-decoration: line-through; color: #b5b5b5">
                                                {{ vuex_huobi }} {{ view_info.priceMarket }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                                <!-- <div class="info-texts">
                                <div class="text-item">
                                    <div class="label">总销量</div>
                                    <div class="text">{{ info.orders }}</div>
                                </div>
                                <div class="text-item">
                                    <div class="label">累计评价</div>
                                    <div class="text">{{ info.comment_num }}</div>
                                </div>
                                <div class="text-item shoucang-box" @click="favourite_toggle()">
                                    <div class="label">
                                        <div class="shoucang-box">
                                            <img v-if="if_shoucang" src="@img/detail-fav-1.png" alt="" />
                                            <img v-else src="@img/detail-fav-0.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="text">
                                        <span>{{ if_shoucang ? '取消收藏' : '收藏商品' }}</span>
                                    </div>
                                </div>
                            </div> -->

                                <div class="sku-box" v-for="(item, index) in sku_list" :key="index">
                                    <div class="sku-label">{{ item.key }}</div>
                                    <div class="skuListBox">
                                        <div
                                            class="skuItem"
                                            :class="{ active: isActive(select_inventoryId.keyIds, item2.id) }"
                                            v-for="(item2, index2) in item.child"
                                            :key="index2"
                                            @click="toggle_sku(item2, index)"
                                        >
                                            <div class="skuItemActive">
                                                <div class="skuDian"></div>
                                            </div>
                                            <div class="skuTitle">{{ item2.title }}</div>
                                            <el-image class="skuBigImg" v-if="item2.image" :src="item2.image" fit="cover"></el-image>
                                        </div>
                                    </div>
                                </div>

                                <div class="shuliang-box">
                                    <div class="sel-num-title">{{ $t('数量') }}</div>
                                    <div class="shuliang">
                                        <div class="minus" @click="selected_num > 1 ? selected_num-- : (selected_num = 1)">
                                            <i class="el-icon-minus"></i>
                                        </div>
                                        <input type="number" readonly="readonly" v-model="selected_num" @blur="onBlur_selected_num" />
                                        <div class="plus" @click="selected_num++"><i class="el-icon-plus"></i></div>
                                    </div>
                                    <span class="inventoryText"> {{ $t('库存') }}： {{ select_inventoryId.kucun }} </span>
                                </div>

                                <div class="videoBtn" @click="showVideo">
                                    <div class="hoverHintText">{{ $t('音色视听') }}</div>
                                </div>
                            </div>
                            <div class="btn-box flex" v-if="lang == 'zh'">
                                <button class="flex-center btn-buy btn-ripple" @click="do_pay_now()">{{ $t('立即购买') }}</button>
                                <button class="flex-center btn-add-cart btn-ripple" @click="do_add_cart()">
                                    <!-- <img src="@img/detail-cart.png" alt="" class="cart"> -->
                                    {{ $t('加入购物车') }}
                                </button>
                                <div class="btn-ripple btn-add-fav" @click="do_add_fav()" :class="{ active: !!(info.ifShoucang == 1) }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="ctx-bottom-container">
                        <!-- <div class="bottom-left">
                            <div class="main-title">相关产品推荐</div>

                            <div class="product-list">
                                <div class="product-item" v-for="(item, index) in list_goods" :key="index" @click="toDetail(item)">
                                    <div class="poster-box scale-box">
                                        <img :src="item.img" alt="" class="poster scale-img" />
                                    </div>
                                    <div class="info-box">
                                        <div class="title">{{ item.title }}</div>
                                        <div class="pirce-box">
                                            <div class="price-info">
                                                <div class="price-1">{{ item.priceSale }}</div>
                                                <div class="price-2">{{ item.priceMarket }}</div>
                                            </div>
                                            <div class="yishou">已售{{ item.orders }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="bottom-right">
                            <div class="ctx-bottom">
                                <div class="ctx-bottom-inner">
                                    <div class="bottom-nav" v-if="false">
                                        <div class="nav-item" @click="togglePanel('详情')" :class="active_panel == '详情' ? 'active' : ''">
                                            商品详情
                                        </div>

                                        <div class="nav-item" @click="togglePanel('评价')" :class="active_panel == '评价' ? 'active' : ''">
                                            累计评价
                                            <!-- <span class="count-num">{{ count_comments }}</span> -->
                                        </div>

                                        <!-- <el-popover placement="bottom" trigger="click">
                                            <div class="pop-kefu">
                                                <div class="pop-kefu-inner">
                                                    <div class="kefu-tip">请微信扫描下方二维码</div>
                                                    <img class="kefu-code" :src="webConfig.kefu_code" />
                                                </div>
                                            </div>
                                            <button class="contact" slot="reference">
                                                <img src="@img/other/goods-detail-kefu.png" alt />
                                                <span>联系客服</span>
                                            </button>
                                        </el-popover> -->
                                        <!-- <button class="contact" slot="reference" @click="shopcart_add">
                                            <img src="@img/icon-cart-trans.png" alt />
                                            <span>加入购物车</span>
                                        </button> -->
                                    </div>

                                    <div class="detail-content-box" v-if="active_panel == '详情'">
                                        <div class="detailFlexBox">
                                            <div class="panel-title">{{ $t('参数配置') }}</div>
                                            <div class="goComment" @click="togglePanel('评价')">
                                                {{ $t('评论') }}（{{ info.commentNum ? info.commentNum : 0 }}）
                                            </div>
                                        </div>
                                        <div class="panel-title-line"></div>
                                        <div class="rich-html" v-if="!isH5" v-html="lang == 'en' ? info.enContent : info.content"></div>
                                        <div class="rich-html" v-else v-html="lang == 'en' ? info.en_mb_content : info.mb_content"></div>
                                        <!-- <div class="rich-html" v-html="info.cont2"></div>
                                        <div class="rich-html" v-html="info.cont3"></div> -->
                                        <!-- <div class="productSwtichBox">
                                            <div class="productSwtichBtn" v-if="info.up && info.up.title" @click="goProduct(info.up)">
                                                <div class="lastBtn"></div>
                                                <div class="productSwtichText">上一个：{{ info.up.title }}</div>
                                            </div>
                                            <div v-else></div>
                                            <div class="productSwtichBtn" v-if="info.last && info.last.title" @click="goProduct(info.last)">
                                                <div class="productSwtichText">下一个：{{ info.last.title }}</div>
                                                <div class="nextBtn"></div>
                                            </div>
                                            <div v-else></div>
                                        </div> -->
                                    </div>

                                    <div class="comment-box" v-if="active_panel == '评价'">
                                        <div class="detailFlexBox">
                                            <div class="panel-title" data-title="评论">{{ $t('用户评论') }}（{{ info.commentNum }}）</div>
                                            <div class="goComment" @click="togglePanel('详情')">{{ $t('参数配置') }}</div>
                                        </div>

                                        <div class="panel-title-line"></div>

                                        <review_list :list="reviews" />

                                        <div class="pagination-box" style="margin-top: 80px" v-if="info.commentNum">
                                            <el-pagination
                                                background
                                                layout="total, prev, pager, next"
                                                @current-change="changePage_comment"
                                                :current-page.sync="pagination.page"
                                                :page-size="pagination.pageNum"
                                                :total="info.commentNum"
                                            ></el-pagination>
                                        </div>

                                        <div class="detail-empty" v-else>
                                            <el-empty :description="$t('没有查询到评论信息...')"></el-empty>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            :title="videoTitle"
            custom-class="modal-custom"
            :close-on-click-modal="false"
            :visible.sync="videoWinShow"
            :before-close="onModalClose"
        >
            <div class="videoBox" v-if="videoUrl && videoUrl[0]">
                <ali-video :mediaUrl="videoUrl[0]"></ali-video>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// import { Swiper, SwiperOptions, Pagination, Navigation } from "swiper";
// import "swiper/swiper-bundle.min.css";

import Swiper from 'swiper' // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入

import product_add_cart_success_modal from '@/components/product/product_add_cart_success_modal.vue'
import carouselComponent from '@/components/goods/carouselComponent.vue' //左侧轮播
import review_list from '@/components/review/review_list.vue'
import detailLunbo from '@/components/detail/detailLunbo.vue'
import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'
import aliVideo from '@/components/aliVideo/aliVideo'
import { mapState } from 'vuex'
import { Loading } from 'element-ui'
import goods_image_mask from '@/components/goods_image_mask.vue'

export default {
    name: 'goods-detail',
    components: {
        product_add_cart_success_modal,
        carouselComponent,
        review_list,
        detailLunbo,
        pageBreadcrumb,
        aliVideo,
        goods_image_mask,
        // QRCode,
        // modalLoading,
        // modalYaoqing,
        // goodsCouponList,
    },
    data() {
        return {
            isH5: false,
            info: {},
            is_fav: false,
            reviews: [],
            pagination: {
                page: 1,
                pageNum: 10,
            },

            is_prod: process.env.NODE_ENV == 'production',

            detailImages: [],

            Loading,
            loadingInstance: null,

            query_wenxian_done: false,
            activeCate: {
                route: '/',
            },

            list_goods: [],
            product_list: [],
            group_list_wenxian: [],
            list_wenxian: [],
            count_wenxian: 0,
            query_field_done: false, //参数字段
            field_list: [],
            all_field: [],

            id: this.$route.query.id || '', //规格id
            product_id: '', //产品id

            //规格数量
            selected_num: 1, //商品数量
            sku_list: [], //规格列表

            sku_select_obj: [], // 选中的规格

            // 其他
            active_panel: '详情', //详情

            isFavourite: false, //未收藏

            count_comments: 0, // 评论量
            selectedSkuComb: {}, //选择的商品规格信息 立即购买需要金额
            curr: {}, //产品
            detail: {}, //产品

            swiperImgs: [], //轮播图
            swiperIndex: 0,

            nav_option: [],

            videoWinShow: false,
            videoTitle: '',
            videoUrl: '',

            select_inventoryId: {}, // 根据选择的规格，生成的inventory对象
            inventorysObj: {}, // 规格列表对象
            guigeMode: '',
        }
    },

    computed: {
        isActive() {
            return (keyIds, id) => {
                if (keyIds && id && this.guigeMode == '多规格') {
                    let arr = keyIds.split('-')
                    for (let index = 0; index < arr.length; index++) {
                        let item = arr[index]
                        if (item == id) {
                            return true
                        }
                    }
                    return false
                } else if (this.guigeMode == '单规格') {
                    return true
                } else {
                    return false
                }
            }
        },

        poster() {
            let ret = ''
            if (this.info.images && this.info.images.length) {
                ret = this.info.images[0]
            }
            return ret
        },

        huoqi_text() {
            let text = '现货'
            if (this.info.skuDay) {
                let num = parseInt(this.info.skuDay)
                if (num) {
                    text = '货期' + num + '天'
                }
            }
            return text
        },
    },

    watch: {
        '$route.query.id'() {
            location.reload()
        },
        sku_select_obj: {
            immediate: true,
            deep: true,
            handler(newV) {
                if (this.detail && this.detail.inventorys) {
                    // 更新选中的规格对象
                    this.select_inventoryId = this.queryInventory()
                }
            },
        },
    },

    created() {
        this.isH5 = this.mix_isH5()
        this.query_product_detail()
    },

    mounted() {
        this.swiperInit()
    },

    beforeDestroy() {
        //console.log("销毁详情页 handleScrollEvent");

        document.removeEventListener('scroll', this.handleScrollEvent)
    },

    methods: {
        // 根据现有的sku_select_obj，返回Inventory
        queryInventory() {
            if (this.guigeMode == '多规格') {
                let inventorysObj = this.inventorysObj
                let keyIdStr = ''
                this.sku_select_obj.forEach((item, index) => {
                    if (index == 0) {
                        keyIdStr = item.id
                    } else {
                        keyIdStr += `-${item.id}`
                    }
                })
                return inventorysObj[keyIdStr]
            } else {
                let inventorysObj = this.inventorysObj
                return inventorysObj[this.sku_select_obj[0]['id']]
            }
        },
        switchImg(index) {
            this.swiperIndex = index
        },
        swiperInit() {
            this.swiper = new Swiper('.swiperBigBox', {
                loop: true, // 无缝
                // autoplay: {
                //     //自动开始
                //     delay: 3000, //时间间隔
                //     disableOnInteraction: false, //*手动操作轮播图后不会暂停*
                // },
                // paginationClickable: true,
                slidesPerView: 6,
                // 一组三个
                spaceBetween: 4,
                // 间隔
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.swiperNextBtn',
                    prevEl: '.swiperLastBtn',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 2,
                    },
                    1024: {
                        slidesPerView: 6,
                        spaceBetween: 4,
                    },
                },
                // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
                observer: true,
                observeParents: true,
                // 如果需要分页器
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true, // 分页器可以点击
                // },
            })
        },
        goProduct(item) {
            this.$router.push({
                path: '/product-detail',
                query: {
                    id: item.inventoryId,
                },
            })
        },
        showVideo() {
            this.videoUrl = this.info.videoUrl
            this.$nextTick(() => {
                this.videoWinShow = true
            })
        },
        onModalClose() {
            this.videoUrl = ''
            this.videoWinShow = false
        },
        toDetail(item) {
            this.$router.push(`/product-detail?id=${item.inventoryId}`)
        },

        query_product_detail() {
            this.$load.open()
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'product_detail',
                    inventoryId: this.id,
                    ifShowSku: 1, //是否展示全部规格skus：0-不需要展示 1-需要展示（规格以组合形式展示，即规格1,规格2 组合一起的）
                },
            }).then(async (res) => {
                await this.$load.close()
                let { code, data, message } = res
                if (res.code == 200) {
                    this.info = data
                    this.videoTitle = data.title

                    if (data.channel_title && data.channel_title_up) {
                        this.nav_option = [
                            { title: this.$t('首页'), path: '/' },
                            { title: this.$t('产品'), path: '/productListFirst' },
                            {
                                title: this.lang == 'en' ? data.channel_title_up_en : data.channel_title_up,
                                path: `/productListFirst?id=${data.channel_id_up}&title=${
                                    this.lang == 'en' ? data.channel_title_up_en : data.channel_title_up
                                }`,
                            },
                            {
                                title: this.lang == 'en' ? data.channel_title_en : data.channel_title,
                                path: `/productListFirst?id=${data.channelId}&title=${
                                    this.lang == 'en' ? data.channel_title_en : data.channel_title
                                }&titleParent=${data.channel_title_up}`,
                            },
                            { title: this.lang == 'en' ? data.enTitle : data.title, path: '' },
                        ]
                    } else if (data.channel_title && !data.channel_title_up) {
                        this.nav_option = [
                            { title: this.$t('首页'), path: '/' },
                            { title: this.$t('产品'), path: '/productListFirst' },
                            {
                                title: this.lang == 'en' ? data.channel_title_en : data.channel_title,
                                path: `/productListFirst?id=${data.channelId}&title=${
                                    this.lang == 'en' ? data.channel_title_en : data.channel_title
                                }`,
                            },
                            { title: this.lang == 'en' ? data.enTitle : data.title, path: '' },
                        ]
                    } else {
                        this.nav_option = [
                            { title: this.$t('首页'), path: '/' },
                            { title: this.$t('产品'), path: '/productListFirst' },
                            { title: this.lang == 'en' ? data.enTitle : data.title, path: '' },
                        ]
                    }

                    this.add_history_record()
                    // this.reviews = data.commentList;
                    this.query_reviews() //评论

                    this.curr = data
                    this.detail = data

                    if (data.skuLists.length == 0) {
                        // 单规格
                        this.guigeMode = '单规格'
                        let inventorysObj = {}
                        inventorysObj[data.inventorys[0].inventoryId] = data.inventorys[0]
                        this.inventorysObj = inventorysObj
                    } else {
                        // 多规格
                        this.guigeMode = '多规格'
                        let inventorysObj = {}
                        data.inventorys.forEach((item, index) => {
                            inventorysObj[item.keyIds] = item
                        })
                        this.inventorysObj = inventorysObj
                    }

                    this.swiperImgs = data.images
                    this.detailImages = data.images.map((v, i) => ({
                        index: i,
                        image: v,
                    }))

                    this.posterSrc = data.images[0]
                    this.set_sku(data)
                } else {
                    if (message == '商品不存在或已下架') {
                        alertErr(this.$t('商品不存在或已下架'))
                        setTimeout(() => {
                            this.$router.push('/')
                        }, 1000)
                    }
                }
                // this.hideLoading()
            })
        },

        //查询评论列表
        query_reviews() {
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'product_comments',
                    productId: this.info.productId,
                    ...this.pagination,
                },
            }).then((res) => {
                let { code, data, count } = res
                if (code == 200) {
                    this.reviews = data.list
                }
            })
        },
        add_history_record() {
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'product_operate',
                    productId: this.info.productId,
                    operateType: 2, //1-关注 2-足迹
                    operateSence: 0, //0-关注（添加记录） 1-取消关注（删除记录）
                },
            }).then((res) => {})
        },
        do_add_fav() {
            this.$load.open()
            if (!this.mix_get_login_status()) {
                return
            }

            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'product_operate',
                    productId: this.info.productId,
                    operateType: 1, //1-关注 2-足迹
                    operateSence: 0, //0-关注（添加记录） 1-取消关注（删除记录）
                },
            }).then((res) => {
                this.$load.close()
                if (res.code == 200) {
                    this.info.ifShoucang = this.info.ifShoucang == 0 ? 1 : 0
                }
            })
        },
        //设置规格
        set_sku(data) {
            if (data.skuLists.length == 0) {
                // 单规格
                if (!data.inventorys || data.inventorys.length == 0) {
                    this.$alert(this.$t('商品配置有误，请检查商品配置！'))
                    return
                }
                this.sku_list = [
                    {
                        key: '规格',
                        child: [
                            {
                                id: data.inventorys[0].inventoryId,
                                title: '默认',
                            },
                        ],
                    },
                ]
                // 选中对象初始化，默认选中第一项
                this.sku_select_obj = []
                this.sku_select_obj.push(this.sku_list[0].child[0])
            } else {
                // 多规格
                this.sku_list = data.skuLists
                // 选中对象初始化，默认选中第一项
                this.sku_select_obj = []
                for (let i = 0; i < data.skuLists.length; i++) {
                    this.sku_select_obj.push(data.skuLists[i].child[0])
                }
            }
        },

        //切换规格
        toggle_sku(item, index) {
            let last_sku_select_obj = this.$cloneDeep(this.sku_select_obj) // 备份原来选择的规格
            this.sku_select_obj[index] = item
            this.sku_select_obj = this.$cloneDeep(this.sku_select_obj)
            let inventorysObj = this.queryInventory()
            if (!inventorysObj || !inventorysObj.kucun || inventorysObj.kucun == 0) {
                this.sku_select_obj = last_sku_select_obj // 恢复原来选择的规格
                alertErr(this.$t('没有库存了'))
                return
            }
            if (inventorysObj.kucun) {
                if (this.selected_num > inventorysObj.kucun) {
                    this.selected_num = inventorysObj.kucun
                }
            }
        },

        //立即购买
        do_pay_now() {
            if (!this.mix_get_login_status()) {
                return
            }
            if (!this.select_inventoryId.inventoryId) {
                alertErr(this.$t('请选择商品规格'))
                return false
            }

            if (this.select_inventoryId.kucun < this.selected_num) {
                alertErr(this.$t('该商品库存不足,无法购买'))
                return false
            }

            let info = this.info
            let data_format = [
                {
                    title: info.title,
                    image: info.thumb,
                    inventoryId: this.select_inventoryId.inventoryId,
                    productId: info.productId,
                    keyVals: this.select_inventoryId.keyVals,
                    num: this.selected_num,
                    priceSale: this.select_inventoryId.priceSale,
                    priceMarket: this.select_inventoryId.priceMarket,
                },
            ]
            let str_data = JSON.stringify(data_format)
            this.$store.commit('set_cache_payment_products', str_data)
            this.$router.push({
                path: '/order-submit',
            })
        },

        onBlur_selected_num() {
            this.selected_num = parseInt(this.selected_num) || 1
        },

        //购车添加商品
        do_add_cart() {
            if (!this.mix_get_login_status()) {
                return
            }

            if (!this.select_inventoryId.inventoryId) {
                alertErr(this.$t('请选择商品规格'))
                return
            }
            if (this.selected_num > this.select_inventoryId.kucun) {
                alertErr(this.$t('该商品库存不足,无法购买'))
                return
            }

            this.$load.open()
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'gouwuche_add',
                    inventoryId: this.select_inventoryId.inventoryId,
                    num: this.selected_num,
                },
            }).then(async (res) => {
                await this.$load.close()
                let { code, data, msg } = res
                if (code == 200) {
                    this.$refs.product_add_cart_success_modal.init({
                        num: this.selected_num,
                        ...this.select_inventoryId,
                    })
                    this.$store.commit('set_vuex_cart_number', data.count)
                }
            })
        },

        //商品评价页面
        go_comments() {
            this.$router.push({
                path: '/comments',
                query: {
                    pid: this.productId,
                },
            })
        },

        //预览图片
        previewImage(src, index, swiperImgs) {
            ImagePreview({
                images: swiperImgs,
                startPosition: index,
                closeable: true,
            })
        },

        //
        togglePanel(name) {
            this.active_panel = name
        },

        //商品评价分页
        changePage_comment(page) {
            this.pagination.page = page
            this.query_reviews() //评论
        },
    },
}
</script>

<style lang="less">
.pop-kefu-inner {
    padding: 25px;

    .kefu-tip {
        margin-bottom: 20px;
    }
}

.detail-qrcode {
    .flex-center();
    text-align: center;

    img {
        border: 1px solid #ddd;
        width: 150px;
        height: 150px;
    }
}
@media screen and (max-width: 1024px) {
    .pop-kefu-inner {
        padding: 25px;

        .kefu-tip {
            margin-bottom: 20px;
        }
    }

    .detail-qrcode {
        .flex-center();
        text-align: center;

        img {
            border: 1px solid #ddd;
            width: 150px;
            height: 150px;
        }
    }
}
</style>

<style scoped lang="less">
.swiperLastBtn {
    width: 20px;
    height: 55px;
    position: absolute;
    left: -25px;
    bottom: 15px;
    cursor: pointer;
    background: url('../../assets/img/productList/swiperLast.png') no-repeat;
    background-size: 100% 100%;

    &:hover {
        background: url('../../assets/img/productList/swiperLast2.png') no-repeat;
        background-size: 100% 100%;
    }
}

.swiperNextBtn {
    width: 20px;
    height: 55px;
    position: absolute;
    right: -25px;
    bottom: 15px;
    cursor: pointer;
    background: url('../../assets/img/productList/swiperNext.png') no-repeat;
    background-size: 100% 100%;

    &:hover {
        background: url('../../assets/img/productList/swiperNext2.png') no-repeat;
        background-size: 100% 100%;
    }
}

.swiperBigBox {
    width: 760px;
    height: 86px;
    position: relative;

    .swiperImg {
        width: 100%;
        height: 86px;
        cursor: pointer;

        &.active {
            border: 4px solid #ff4d00;
        }

        &:hover {
            border: 4px solid #ff4d00;
        }
    }
}

.fill60 {
    width: 100%;
    height: 40px;
}

/deep/ .modal-custom {
    .videoBox {
        width: 100%;
        height: 500px;
        margin: 0 auto;
        .video {
            display: block;
            width: 100%;
            height: 100%;
        }
    }
}
.pop-kefu {
    .pop-kefu-inner {
        text-align: center;

        .kefu-tip {
            text-align: center;
            font-size: 14px;
        }

        .kefu-code {
        }

        .erweima {
        }
    }
}

.phone-tip-inner {
    .flex();
    cursor: pointer;
}

.page {
    background: #ffffff;
    // padding-top: 32px;
    min-height: 50vh;
    font-size: 14px;

    .page-box {
        padding-top: 0;
    }

    .page-inner {
        // overflow: hidden;
        max-width: @width;
        margin: 0 auto;
        margin-top: 0;
        margin-bottom: 0;
        padding-bottom: 50px;

        .main-content {
            // background-color: #fff;

            .ctx-top {
                background: #fff;
                display: flex;
                align-items: flex-start;
            }

            .top-info {
                .product-title {
                    text-align: left;
                    font-size: 20px;
                    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                    font-weight: bold;
                    color: #333333;

                    .state-xiajia {
                        margin-left: 20px;
                        font-weight: normal;
                        font-size: 14px;
                        color: #999;
                        color: #ea3200;
                    }
                }

                .product-other-action {
                    padding: 25px 0;
                    .flex();

                    .action-item {
                        .flex();
                        margin-right: 30px;
                        cursor: pointer;

                        &:hover {
                            span {
                                color: #4ca5e4;
                            }
                        }

                        img {
                            margin-right: 5px;
                            max-width: 20px;
                            max-height: 20px;
                        }

                        span {
                            font-size: 12px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            font-weight: 400;
                            color: #666666;

                            font-size: 16px;
                        }
                    }
                }

                .product-filter {
                    .flex-between();
                    padding: 15px 0;
                    padding-bottom: 0;
                    border: 1px solid #d5d8de;
                    border-left: none;
                    border-right: none;

                    .text {
                        margin-bottom: 15px;
                    }

                    .tabs {
                        flex: 1;
                        .flex();
                        flex-wrap: wrap;

                        .tab-item {
                            margin-right: 15px;
                            margin-bottom: 15px;
                            min-width: 32px;
                            padding: 0 5px;
                            height: 24px;
                            line-height: 24px;
                            background: #ffffff;
                            border-radius: 3px 3px 3px 3px;
                            border: 1px solid #a6a6a6;

                            font-size: 12px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            font-weight: 400;
                            color: #999999;
                            font-size: 16px;

                            &.active {
                                background: #4ca5e4;
                                color: #fff;
                                border-color: #4ca5e4;
                            }
                        }
                    }

                    .fuli {
                        img {
                            height: 24px;
                        }
                    }
                }
            }

            .ctx-top {
                padding: 0;
                display: flex;
                justify-content: space-between;

                .ctx-left {
                    width: 760px;
                    position: relative;

                    .elImg {
                        width: 760px;
                        height: 530px;
                        position: relative;
                    }

                    .promotion-box {
                        position: absolute;
                        bottom: 0;
                        width: 100%;

                        .limit-end-box {
                            font-size: 0.3rem;
                            color: #4ca5e4;
                            font-weight: bold;
                            text-align: center;
                            padding-bottom: 0.5rem;
                        }
                    }

                    .shoucang-box {
                        margin-top: 20px;
                        .flex-between();
                        width: 100%;

                        .yes {
                            color: #f00;
                        }

                        .no {
                            color: #000;
                        }

                        .shoucang-left {
                            cursor: pointer;
                            .flex();

                            img {
                                width: 20px;
                                margin-right: 15px;
                            }

                            span {
                                font-size: 16px;
                                font-family: PingFang SC;
                                font-weight: 400;
                                line-height: 36px;
                                color: #333333;
                            }
                        }

                        .shoucang-right {
                            cursor: pointer;
                            .flex();

                            img {
                                width: 20px;
                                margin-right: 15px;
                            }

                            span {
                                font-size: 16px;
                                font-family: PingFang SC;
                                font-weight: 400;
                                line-height: 36px;
                                color: #333333;
                            }
                        }
                    }
                }

                .ctx-right {
                    flex: 2;
                    min-height: 598px;
                    margin-left: 65px;
                    text-align: left;
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    flex-direction: column;

                    .otherBox {
                        width: 100%;
                    }

                    .detail-title {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .title-text {
                            flex: 1;
                            font-weight: bold;
                            font-size: 26px;
                            color: #000000;
                            line-height: 35px;
                        }

                        .price-box {
                            margin-left: 100px;
                            font-weight: bold;
                            font-size: 35px;
                            color: #ff0000;
                            line-height: 35px;
                        }
                    }

                    .detail-desc {
                        margin-top: 30px;
                        margin-bottom: 40px;
                        font-family: OPPOSans, OPPOSans;
                        // font-weight: bold;
                        font-size: 16px;
                        color: #555555;
                        line-height: 30px;
                    }

                    .info-box {
                        padding: 25px 20px;
                        background: #f7f7f7;
                        background-repeat: no-repeat;
                        background-size: 100% 100%;

                        .list {
                            .item {
                                .flex();

                                .label {
                                    width: 80px;
                                    font-size: 16px;
                                    font-family: PingFang SC, PingFang SC;
                                    font-weight: 500;
                                    color: #353535;
                                }

                                .vals {
                                    .flex();
                                    flex: 1;

                                    font-size: 16px;
                                    font-family: PingFang SC, PingFang SC;
                                    font-weight: 500;
                                    color: #353535;

                                    &.vals-price {
                                        font-size: 24px;
                                        font-family: PingFang SC, PingFang SC;
                                        font-weight: bold;
                                        color: #eb0611;
                                    }

                                    .val {
                                        flex: 1;
                                    }
                                }
                            }
                        }

                        .price {
                            .flex();

                            .number {
                                font-size: 28px;
                                font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                                font-weight: bold;
                                color: #ea3200;
                            }
                        }
                    }

                    .info-texts {
                        .flex-between();
                        padding: 0 32px;
                        height: 45px;
                        background: #f8f8f8;

                        .text-item {
                            .flex();

                            .label {
                                font-size: 14px;
                                color: #6a6a6a;
                            }

                            .text {
                                margin-left: 6px;
                                font-size: 16px;
                                color: #e1251b;
                            }
                        }

                        .shoucang-box {
                            cursor: pointer;

                            img {
                                width: 18px;
                            }

                            .text {
                                font-size: 13px;
                                color: #747474;
                            }
                        }
                    }

                    .sku-box {
                        width: 100%;
                        margin-top: 40px;
                        display: flex;
                        align-items: flex-start;

                        .sku-label {
                            width: 80px;
                            font-weight: bold;
                            font-size: 17px;
                            color: #000000;
                            line-height: 25px;
                            margin-right: 5px;
                        }

                        .skuListBox {
                            flex: 1;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            flex-wrap: wrap;

                            .skuItem {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                margin-bottom: 32px;
                                cursor: pointer;
                                margin-right: 54px;
                                position: relative;

                                .skuBigImg {
                                    display: none;
                                    z-index: 9;
                                    width: 200px;
                                    height: 200px;
                                    position: absolute;
                                    bottom: -220px;
                                    left: 10px;
                                    border-radius: 10px;
                                    overflow: hidden;
                                    background: #f8f8f8;
                                }

                                &:hover {
                                    .skuTitle {
                                        color: #ff4d00;
                                    }

                                    .skuBigImg {
                                        display: block;
                                    }
                                }

                                .skuItemActive {
                                    width: 26px;
                                    height: 26px;
                                    border-radius: 50%;
                                    border: 1px solid #000000;
                                    box-sizing: border-box;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;

                                    .skuDian {
                                        width: 12px;
                                        height: 12px;
                                        border-radius: 50%;
                                        background: #ff4d00;
                                        display: none;
                                    }
                                }

                                .skuTitle {
                                    margin-left: 12px;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #555555;
                                    line-height: 16px;

                                    &.active {
                                        color: #ff4d00;
                                    }
                                }

                                &.active {
                                    .skuTitle {
                                        color: #ff4d00;
                                    }

                                    .skuDian {
                                        display: block;
                                    }
                                }
                            }
                        }
                    }

                    .sku-list {
                        flex: 1;
                        .flex();
                        flex-wrap: wrap;

                        .sku-item {
                            // .flex-center();
                            margin-bottom: 10px;
                            padding: 0 6px;
                            margin-right: 20px;
                            text-align: center;
                            line-height: 36px;
                            min-width: 108px;
                            height: 36px;
                            background: #ffffff;
                            border-radius: 0px 0px 0px 0px;
                            border: 1px solid #dddddd;
                            font-size: 14px;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 500;
                            color: #333333;

                            &:disabled {
                                cursor: not-allowed;
                                opacity: 0.6;
                                color: #ccc;
                            }

                            &.active {
                                border: 1px solid #4ca5e4;
                                color: #eb0611;

                                .img-box {
                                    img {
                                        visibility: visible !important;
                                    }
                                }

                                .text {
                                    color: #4ca5e4;
                                }

                                .price {
                                    color: #4ca5e4;
                                }
                            }

                            .text {
                                text-align: center;
                                flex: 1;
                                font-size: 14px;
                                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                                font-weight: 400;
                                color: #333333;
                            }
                        }
                    }

                    .phone-tip {
                        margin-top: 16px;
                        display: flex;
                        justify-content: flex-end;

                        font-size: 14px;
                        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                        font-weight: 400;
                        color: #808080;

                        img {
                            margin-left: 10px;
                            width: 24px;
                        }
                    }

                    .shuliang-box {
                        margin-top: 0px;
                        margin-bottom: 32px;
                        .flex();

                        .el-icon-minus {
                            font-size: 18px;
                            line-height: 18px;
                            color: #000000;
                        }

                        .el-icon-plus {
                            font-size: 18px;
                            line-height: 18px;
                            color: #000000;
                        }

                        .inventoryText {
                            font-weight: 400;
                            font-size: 14px;
                            color: #777777;
                            line-height: 14px;
                            position: relative;
                            top: 8px;
                        }

                        .sel-num-title {
                            min-width: 84px;
                            font-weight: bold;
                            font-size: 17px;
                            color: #000000;
                            line-height: 17px;
                        }

                        .shuliang {
                            width: 116px;
                            height: 35px;
                            .flex();

                            div {
                                width: 30px;
                                height: 30px;
                                cursor: pointer;
                                user-select: none;

                                &:hover {
                                    opacity: 0.8;
                                }

                                img {
                                    width: 30px;
                                    height: 30px;
                                    vertical-align: bottom;
                                }
                            }

                            .minus {
                                width: 35px;
                                height: 35px;
                                .flex();
                                font-size: 22px;
                                color: #000000;
                                border-top: 1px solid #707070;
                                border-left: 1px solid #707070;
                                border-bottom: 1px solid #707070;
                                text-align: center;
                                line-height: 35px;
                                position: relative;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }

                            .icon {
                                width: 10px;
                                height: 10px;
                                position: relative;
                                background: url('../../assets/img/productList/jia.png') no-repeat;
                                background-size: 100% 100%;
                            }

                            .icon2 {
                                width: 10px;
                                height: 10px;
                                position: relative;
                                background: url('../../assets/img/productList/jian.png') no-repeat;
                                background-size: 100% 100%;
                            }

                            input {
                                outline: none;
                                // margin: 0 10px;
                                display: inline-block;
                                border: 1px solid #707070;

                                width: 35px;
                                height: 35px;
                                text-align: center;

                                font-size: 18px;
                                line-height: 35px;
                                color: #000000;
                            }

                            input::-webkit-outer-spin-button,
                            input::-webkit-inner-spin-button {
                                -webkit-appearance: none !important;
                            }

                            /* chrome */
                            input[type='number'] {
                                -moz-appearance: textfield;
                                /* firefox */
                            }

                            .plus {
                                width: 35px;
                                height: 35px;
                                .flex();
                                font-size: 22px;
                                color: #000000;
                                border-top: 1px solid #707070;
                                border-right: 1px solid #707070;
                                border-bottom: 1px solid #707070;
                                text-align: center;
                                line-height: 35px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }

                    .videoBtn {
                        width: 38px;
                        height: 25px;
                        background: url('../../assets/img/productList/video.png') no-repeat;
                        background-size: 100% 100%;
                        cursor: pointer;
                        position: relative;
                        margin-bottom: 20px;

                        &:hover {
                            background: url('../../assets/img/productList/video2.png') no-repeat;
                            background-size: 100% 100%;

                            .hoverHintText {
                                display: flex;
                            }
                        }

                        .hoverHintText {
                            padding: 10px;
                            background: rgba(85, 85, 85, 0.1);
                            border-radius: 0px 0px 0px 0px;
                            border: 1px solid rgba(112, 112, 112, 0.5);
                            display: none;
                            align-items: center;
                            justify-content: center;
                            font-weight: 400;
                            font-size: 14px;
                            color: #555555;
                            line-height: 14px;
                            position: absolute;
                            top: 25px;
                            left: 38px;
                        }
                    }

                    .sel-num-title {
                        margin: 20px 0;
                        font-weight: bold;
                        font-size: 17px;
                        color: #000000;
                        line-height: 30px;
                    }

                    .btn-box {
                        button {
                            margin-right: 20px;
                            font-size: 16px;
                            transition: 0.3s;

                            &:hover {
                                opacity: 0.8;
                            }
                        }

                        .btn-buy {
                            width: 200px;
                            height: 50px;
                            background: #ff4d00;
                            border-radius: 0px 0px 0px 0px;
                            color: #ffffff;
                            border: none;
                            font-weight: 400;
                            font-size: 16px;
                            line-height: 16px;
                        }

                        .btn-add-cart {
                            width: 200px;
                            height: 50px;
                            border-radius: 0px 0px 0px 0px;
                            border: 1px solid #000000;
                            font-weight: 400;
                            font-size: 16px;
                            color: #000000;
                            line-height: 16px;
                            margin-right: 30px;
                        }

                        .btn-add-fav {
                            cursor: pointer;
                            width: 50px;
                            height: 50px;
                            background: url('../../assets/img/productList/collect.png') no-repeat;
                            background-size: 100% 100%;

                            &.active {
                                background: url('../../assets/img/productList/collect2.png') no-repeat;
                                background-size: 100% 100%;
                            }
                        }
                    }
                }
            }

            .ctx-bottom-container {
                margin-top: 80px;
                display: flex;
                justify-content: space-between;

                .bottom-left {
                    width: 220px;
                    background: #fff;
                    font-weight: 400;
                    font-size: 16px;
                    color: #333333;
                }

                .bottom-right {
                    width: 1164px;
                    width: 100%;
                    background: #fff;
                }
            }

            .ctx-bottom {
                // margin-top: 50px;
            }

            .ctx-bottom-inner {
                width: 100%;
                text-align: left;

                .panel-title {
                    margin-bottom: 20px;
                    font-weight: bold;
                    font-size: 30px;
                    color: #000000;
                    line-height: 30px;
                }

                .goComment {
                    font-weight: 400;
                    font-size: 18px;
                    color: #000000;
                    line-height: 18px;
                    cursor: pointer;
                }

                .panel-title-line {
                    margin-bottom: 50px;
                    width: 100%;
                    height: 2px;
                    background: rgba(0, 0, 0, 0.8);
                }
            }
        }
    }
}

.fill100 {
    width: 100%;
    height: 100px;
}

.bottom-nav {
    background: #f9f9f9;
    position: relative;
    border-bottom: 1px solid #ddd;
    display: flex;
    height: 48px;
    /*no */
    line-height: 48px;
    /*no */

    .count-num {
        color: #4ca5e4;
    }

    .nav-item {
        min-width: 100px;
        text-align: center;
        cursor: pointer;
        text-align: center;
        margin-right: 10px;
        // background: #fff;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #000000;

        &:last-child {
            margin-right: 0;
        }

        &.active {
            font-weight: bold;
            position: relative;
            background: #333333;
            color: #ffffff;

            // &::after {
            //   content: "";
            //   position: absolute;
            //   left: 50%;
            //   transform: translate(-50%);
            //   bottom: 0;
            //   width: 40px;
            //   height: 4px;
            //   background: #eb0611;
            //   border-radius: 50px 50px 50px 50px;
            // }

            .count-num {
                color: #fff;
            }
        }
    }

    button {
        position: absolute;
        right: 0;
        top: 8px;
        /*no */
        right: 8px;
        /*no */
        min-width: 126px;
        /*no */
        height: 32px;
        /*no */

        &.contact {
            background: #4ca5e4;
            .flex-center();
            right: 20px;

            &:hover {
                opacity: 0.8;
            }

            img {
                width: 20px;
                margin-right: 10px;
                vertical-align: bottom;
            }

            span {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 20px;
                color: #ffffff;
            }
        }
    }
}

.detail-content {
    margin-top: 30px;

    .big-img-list {
        .big-img-item {
            margin-bottom: 10px;
            padding: 30px;
            margin: 10px auto;

            img {
                width: 400px;
                height: 300px;
            }
        }
    }
}

.detail-content-box {
    min-height: 10vh;
    // padding: 0;
    text-align: left;

    .detailFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    /deep/ img {
        display: block;
        max-width: 100%;
        margin: 0 auto;
    }

    .params-html {
        margin-bottom: 32px;

        .params-box {
            .params-item {
                .flex();
                border: 1px solid #ccc;
                border-bottom: none;

                &:last-child {
                    border-bottom: 1px solid #ccc;
                }

                &[data-key='target_backmsg'] {
                    display: none;
                }

                .params-label {
                    display: flex;
                    align-items: center;
                    align-self: stretch;
                    background: #f7f7f7;
                    min-height: 50px;
                    line-height: 50px;
                    width: 300px;
                    padding: 0 24px;
                    font-size: 14px;
                    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                    font-weight: bold;
                    color: #666666;

                    font-size: 16px;
                }

                .params-val {
                    flex: 1;
                    min-height: 50px;
                    line-height: 50px;
                    padding: 0 24px;
                    font-size: 14px;
                    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                    font-weight: bold;
                    color: #666666;

                    font-size: 16px;
                }
            }
        }
    }
}

.rich-html {
    line-height: 2;
    // overflow-x: auto;

    /deep/ table {
        width: 100%;
        margin: 0 auto;
        table-layout: auto;

        td {
            // border: 1px solid #aaa;
            border-bottom: none;
            border-right: none;
            min-height: 3.6rem;
            height: auto !important;
            line-height: 3rem;

            p,
            span,
            strong,
            i {
                font-size: 1.2rem;
            }
        }

        tr {
            height: auto !important;

            &.firstRow {
                td {
                    p,
                    span,
                    strong,
                    i {
                        font-size: 1.4rem;
                    }
                }
            }
        }

        tr td:last-child {
            // border-right: 1px solid #aaa;
        }

        tr:last-child {
            td {
                // border-bottom: 1px solid #aaa;
            }
        }
    }
}

.pagation-box {
    margin-top: 20px;
    margin-bottom: 20px;
}

.comment-box {
    min-height: 10vh;
    // margin-top: 20px;

    .detailFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .goComment {
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        line-height: 18px;
        cursor: pointer;
    }

    .comment-title {
        display: flex;
        background-color: #eee;
        align-items: center;
        color: #fff;
        width: 100%;

        color: #000;

        .comment-title-text {
            padding: 5px 30px;
            margin-right: 20px;
            background-color: #4ca5e4;
            color: #fff;
        }
    }

    label {
        width: 70px;

        input {
            margin-right: 10px;
        }
    }

    .comment-list {
        margin-top: 20px;
        font-size: 14px;
        color: #000;
        text-align: left;

        .comment-item {
            background-color: #eee;
            padding: 20px;
            min-height: 50px;
            margin-bottom: 20px;

            .comment-bottom {
                margin-top: 10px;
                display: flex;
                align-items: center;

                .left {
                    flex: 3;

                    .img-list {
                        display: flex;

                        .img-item {
                            padding: 10px;
                        }

                        img {
                            width: 80px;
                            height: 80px;
                            padding: 10px;
                            background-color: #fff;
                            margin-right: 10px;
                        }
                    }
                }

                .right {
                    flex: 1;
                }
            }
        }
    }
}

.bottom-left {
    .main-title {
        position: relative;
        border-bottom: 1px solid #eeeeee;
        line-height: 45px;
        padding-left: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #333333;

        &::after {
            position: absolute;
            content: '';
            background: #333;
            bottom: 0;
            width: 96px;
            left: 16px;
            height: 2px;
        }
    }
}

.productSwtichBox {
    margin-top: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .productSwtichBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .lastBtn {
            width: 36px;
            height: 36px;
            background: url('../../assets/img/news/last.png') no-repeat;
            background-size: 100% 100%;
            margin-right: 20px;
        }

        .productSwtichText {
            font-weight: 400;
            font-size: 16px;
            color: #555555;
            line-height: 16px;
        }

        .nextBtn {
            width: 36px;
            height: 36px;
            background: url('../../assets/img/news/next.png') no-repeat;
            background-size: 100% 100%;
            margin-left: 20px;
        }

        &:hover {
            .lastBtn {
                background: url('../../assets/img/news/last2.png') no-repeat;
                background-size: 100% 100%;
            }

            .nextBtn {
                background: url('../../assets/img/news/next2.png') no-repeat;
                background-size: 100% 100%;
            }

            .productSwtichText {
                color: #ff4d00;
            }
        }
    }
}

.product-list {
    margin-top: 12px;

    .product-item {
        margin-bottom: 10px;
        margin-right: 16px;
        margin-top: 16px;
        width: 220px;
        // height: 349px;
        background: #ffffff;
        cursor: pointer;

        &:nth-child(6n) {
            margin-right: 0;
        }

        &:nth-child(-n + 6) {
            margin-top: 0;
        }

        &:hover {
            .title {
                color: #4ca5e4 !important;
            }
        }

        .poster-box {
            width: 220px;
            height: 220px;

            .poster {
                width: 220px;
                height: 220px;
            }
        }

        .info-box {
            padding: 13px 15px 0;

            .title {
                .ellipsis-1();
                font-weight: 400;
                font-size: 14px;
                color: #333333;
            }

            .pirce-box {
                margin-top: 15px;
                .flex-between();

                .price-info {
                    .flex();

                    .price-1 {
                        margin-right: 10px;
                        font-family: Arial, Arial;
                        font-weight: 400;
                        font-size: 16px;
                        color: #ff3a30;
                    }

                    .price-2 {
                        text-decoration: line-through;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                    }
                }

                .yishou {
                    font-weight: 400;
                    font-size: 12px;
                    color: #999999;
                }
            }

            .act-box {
                margin-top: 15px;
                border-top: 1px solid #ddd;
                padding-top: 5px;
                .flex-between();

                .fav-box {
                    .flex-center();
                    width: fit-content;
                    height: 32px;

                    img {
                        margin-right: 5px;
                        width: 18px;
                        height: 18px;
                    }
                }

                .cart-box {
                    .flex-center();
                    width: 32px;
                    height: 32px;

                    img {
                        width: 32px;
                        height: 32px;
                    }
                }
            }
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/mobile/product-detail.less"></style>
